/**
 * Takes a pathId and returns an unencoded version.
 * Returns empty string if pathId is undefined
 * @param pathId
 */
export const formatDirPath = (pathId?: string): string =>
  (pathId && decodeURIComponent(pathId)) || '';
